import { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

const UpdateKotPrint = (arr1, roomNo, totalAmount,newKotNumber) => {
    const location = useLocation();
        const {  registration,kotNo,id } = location.state || {};
  const [kotData, setKotData] = useState({
    foodItem: [],
    roomNo: roomNo, // Assuming roomNo is passed as an argument
    kotNo: '',
    totalBilling: totalAmount,
    registration:registration
  });
  console.log(newKotNumber,'newKotNumber')
  
  const customerId = localStorage.getItem('customerId');

  const kotPrint = async () => {
    const randomKotNumber = Math.floor(Math.random() * 10000);

    setKotData({
      ...kotData,
      foodItem: arr1,
      roomNo: roomNo,
      kotNo: kotNo,
      totalBilling: totalAmount,
      registration:registration

    });
  };
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  //const customerId = localStorage.getItem('customerId');

  function getFormattedCurrentDate() {
    const now = new Date(); // Get the current date and time
    
    // Format the date as "DD-MM-YYYY"
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-based, so +1
    const year = now.getFullYear();
    
    // Format the time as "HH:MM AM/PM"
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, '0'); // Add leading zero to minutes if needed
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour time, adjusting midnight to 12
    
    const formattedDate = `${day}-${month}-${year}`;
    const formattedTime = `${hours}:${minutes}${period.toLowerCase()}`;
    
    return [formattedDate, formattedTime];
  }

  // useEffect to update date and time when component mounts or customerId/tableNo changes
  useEffect(() => {
    const [formattedDate, formattedTime] = getFormattedCurrentDate();
    setDate(formattedDate);
    setTime(formattedTime);
  }, [customerId]);

//   useEffect(() => {
//     const printKot = async () => {
//       if (kotData.kotNo) {
//         const printData = `
//           <h2>KOT Details</h2>
//           <p>Food Items:</p>
//           <table>
//             <thead>
//               <tr>
//                 <td>Name</td>
//                 <td>Quantity</td>
//                 <td>Price</td>
//               </tr>
//             </thead>
//             <tbody>
//               ${kotData.foodItem.map((item) => `
//                 <tr key="${item._id}">
//                   <td>${item.name}</td>
//                   <td>${item.quantity}</td>
//                   <td>${item.price}</td>
//                 </tr>
//               `).join('')}
//             </tbody>
//           </table>
//           <p>Room No.: ${kotData.roomNo}</p>
//           <p>KOT No.: ${kotData.kotNo}</p>
//         `;
        
//         try {
//           const response = await axios.post('https://api.hotel.tdrsoftware.in/api/kotBillRegister', {
//             customerId: customerId,
//             data: kotData
//           });
          
//           console.log('Bill saved:', response.data);
//           toast.success(response.data.message);
          
//           // Create a hidden iframe
//           const iframe = document.createElement('iframe');
//           iframe.style.position = 'fixed';
//           iframe.style.top = '-9999px'; // Hide offscreen
//           document.body.appendChild(iframe);
          
//           // Write content to iframe
//           const iframeDoc = iframe.contentWindow.document;
//           iframeDoc.open();
//           iframeDoc.write(printData);
//           iframeDoc.close();
          
//           // Trigger print dialog
//           iframe.contentWindow.focus();
//           iframe.contentWindow.print();
          
//           // Remove iframe after printing
//           setTimeout(() => {
//             document.body.removeChild(iframe);
//           }, 1000); // Adjust timeout as needed
         
//         } catch (error) {
//           console.error('Error saving bill:', error);
//           toast.error("Error in Kot billing");
//         }
//       }
//     };

//     printKot();
//   }, [kotData]);
const printKot = async () => {
    try {
      const response = await axios.patch(`https://api.hotel.tdrsoftware.in/api/kotBillUpdate/${customerId}/${id}`, {
        
        data: {
          foodItem: arr1,
        }
       
      });

      toast.success(response.data.message);
      console.log(response.data.updatedFoodItems);

      const data = response.data.updatedFoodItems || []; // Ensure updatedFoodItems is an array

      // Prepare print data with CSS for 3-inch page size
      const printData = `
        <style>
          @page {
            size: 3in auto; /* Set page width to 3 inches */
            margin: 0;
            margin-bottom:10 /* Remove margins for accurate sizing */
          }
          body {
            width: 3in; /* Page width of 3 inches */
            margin: 0;
            margin-bottom: 20px;
            font-size: 12px;
          }
          h2 {
            font-size: 14px;
            margin-bottom: 10px;
          }
          p {
            margin: 5px 0;
            font-size: 12px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }
          td {
            padding: 5px;
            border: 1px solid #000;
          }
          /* Make the name column larger and quantity smaller */
          td.name {
            width: 80%; /* Adjust this width as needed */
          }
          td.quantity {
            width: 20%; /* Adjust this width as needed */
          }
        </style>
        <body>
          <h2>KOT Details:</h2>
          
          <p>KOT No.: ${kotNo}</p>
          
          <p>Date: ${date}</p>
          <p>Time: ${time}</p>
          <p>Food Items:</p>
          <table>
            <thead>
              <tr>
                <td class="name">Name</td>
                <td class="quantity">Quantity</td>
                
              </tr>
            </thead>
            <tbody>
              ${Array.isArray(data) ? data.map((item) => `
                <tr key="${item._id}">
                  <td class="name">${item.name}</td>
                  <td class="quantity">${item.newQuantity - item.oldQuantity}</td>
                 
                </tr>
              `).join('') : ''}
            </tbody>
          </table>
        </body>
      `;

      // Create a hidden iframe for printing
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.top = '-9999px'; // Hide the iframe offscreen
      document.body.appendChild(iframe);

      // Write content to iframe
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printData);
      iframeDoc.close();

      // Trigger print dialog
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      // Remove iframe after printing
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);

    } catch (error) {
      console.error('Error saving bill:', error);
      toast.error('Error in Kot');
    }
  };

  return printKot;
  // Return the function to be used in a button click
};
  


export default UpdateKotPrint;
